'use client'

import clsx from 'clsx'

import Button from 'shared/ui/Button'

import styles from './EditSaleOrderReminderButtons.module.scss'

const EditSaleOrderReminderButtons = ({
  handleCancelEditOrder,
  handleSubmitEditOrder,
  direction
}: {
  handleCancelEditOrder: () => void
  handleSubmitEditOrder?: () => void
  direction?: 'vertical' | 'horizontal'
}) => {
  return (
    <div
      className={clsx(styles.buttonContainer, {
        [styles.horizontal]: direction === 'horizontal'
      })}
    >
      <Button
        variant='primaryOutline'
        fullWidth
        onClick={handleCancelEditOrder}
      >
        Anuluj edycję
      </Button>
      {handleSubmitEditOrder && (
        <Button variant='primary' fullWidth onClick={handleSubmitEditOrder}>
          Zatwierdź edycję
        </Button>
      )}
    </div>
  )
}

export default EditSaleOrderReminderButtons
